import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../../../packages/i18n/src/en.json';
import yo from '../../../packages/i18n/src/yo.json';
import ig from '../../../packages/i18n/src/ig.json';
import ha from '../../../packages/i18n/src/ha.json';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    yo: { translation: yo },
    ig: { translation: ig },
    ha: { translation: ha },
  },
  lng: localStorage.getItem('lang') ?? 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
